<div mat-dialog-title class="modal-title">
  <mat-icon>fact_check</mat-icon>
  <span>
    Respuestas al examen: {{ examName }}
    @if (studentName) {
      <span>({{ studentName }})</span>
    }
  </span>
  <mat-icon class="close-button" (click)="closeModal()"> cancel </mat-icon>
</div>
<mat-dialog-content>
  <div class="note">
    <span> Total de preguntas: {{ totalQuestions }} </span>
    <span> Preguntas obligatorias: {{ requiredQuestions }} </span>
  </div>
  @if (answeredExams) {
    <div class="exams">
      <mat-accordion class="exam exam-accordion">
        @for (answeredExam of answeredExams; track answeredExam.answeredExamId; let i = $index) {
          <mat-expansion-panel hideToggle [expanded]="i === 0">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="exam-title">
                  <span>{{ answeredExam.date | date: 'dd MMM yyyy HH:mm' : '' : 'es' }}</span>
                  <div class="badge">
                    @if (auth.isStaff()) {
                      <button
                        mat-stroked-button
                        color="primary"
                        (click)="downloadAnswers($event, answeredExam)"
                        [disabled]="answeredExam.isDownloadingAnswers"
                      >
                        @if (!answeredExam.isDownloadingAnswers) {
                          Descargar respuestas
                        } @else {
                          <mat-spinner class="primary-spinner"> </mat-spinner>
                        }
                      </button>
                    }
                    <span class="detail">Respuestas correctas: {{ answeredExam.correctAnswers }}</span>
                    @if (answeredExam.approved) {
                      <span class="approved">Aprobado {{ answeredExam.grade }}</span>
                    } @else {
                      <span class="failed">Reprobado {{ answeredExam.grade }}</span>
                    }
                  </div>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="exam-content">
              <div class="answers">
                @for (answer of answeredExam.answers; track answer; let j = $index) {
                  <div class="answer">
                    <div class="answer-header">
                      <label>{{ j + 1 }}. {{ answer.label }}</label>
                      @if (answer.good === true) {
                        <mat-icon color="success">check_circle</mat-icon>
                      } @else if (answer.good === null) {
                        <mat-icon class="gray">do_not_disturb_on</mat-icon>
                      } @else if (answer.good === false) {
                        <mat-icon color="warn">cancel</mat-icon>
                      }
                    </div>
                    <p> <b>Tu respuesta:</b> {{ answer.humanValue }} </p>
                    <p> <b>Respuesta correcta:</b> {{ answer.correctAnswer || '-' }} </p>
                  </div>
                }
              </div>
            </div>
          </mat-expansion-panel>
        }
      </mat-accordion>
    </div>
  }
</mat-dialog-content>
